<template>
    <div class="dashboard-overview-container d-flex justify-content-between flex-column gap-10" :class="{'blue' : info.isActual}">
        <template v-if="info.displayType == 'revenue'">
            <div class="header">
                <h3 v-if="!isDaily" :id="`revenue-daily${id}`">{{ info.title }} <el-tag size="small">{{isGstAdded ? 'Inc-GST' : 'Ex-GST' }}</el-tag></h3>
                <h3 v-if="isDaily" :id="`revenue-weekly${id}`">{{ info.title }} <el-tag size="small">{{isGstAdded ? 'Inc-GST' : 'Ex-GST' }}</el-tag></h3>
            </div>

            <div class="d-flex justify-content-between align-items-center content">
                <div v-if="dataLoading"><i class="el-icon-loading"></i></div>
                <span v-if="!dataLoading">{{ info.value }}</span>
                <div v-if="isEnable && !isDaily" class="option cursor-pointer" @click="showRevenue()">
                    <i :id="`edit-${info.isActual ? 'actual-revenue' : 'target-revenue'}`" class="el-icon-edit-outline"></i>
                </div>
                <div v-if="isEnable && isDaily" class="option cursor-pointer" @click="showRevenue()">
                    <i :id="`edit-weekly-${info.isActual ? 'actual-revenue' : 'target-revenue'}`" class="el-icon-edit-outline"></i>
                </div>
            </div>
        </template>

        <template v-if="info.displayType == 'roster'">
            <div class="header">
                <h3 v-if="!isDaily" :id="`roster-daily${id}`">{{ info.title }}</h3>
                <h3 v-if="isDaily" :id="`roster-weekly${id}`">{{ info.title }}</h3>
            </div>
            <div class="d-flex justify-content-between align-items-center content">
                <div v-if="dataLoading"><i class="el-icon-loading"></i></div>
                <span v-if="!dataLoading && rosterDisplay == 1">{{ info.value }}</span>
                <span v-if="!dataLoading && rosterDisplay == 2">{{ info.hours }}</span>
                <span v-if="!dataLoading && rosterDisplay == 3">{{ info.percentage }}</span>
                <div class="option cursor-pointer" @click="rosterChangeDisplay()"><img id="roster" src="@/assets/t.png" height="20px" class="object-fit-contains" alt=""></div>
            </div>
        </template>

        <template v-if="info.displayType == 'guidance'">
            <div class="header d-flex justify-content-between algin-items-center">
                <h3>{{ info.title }}</h3>
                <div class="option cursor-pointer" @click="guidanceChangeDisplay()"><img src="@/assets/t.png" height="20px" class="object-fit-contains" alt=""></div>
            </div>
            <div class="d-flex justify-content-between align-items-center content guidance">
                <div v-if="dataLoading"><i class="el-icon-loading"></i></div>
                <div v-if="!dataLoading && !guidanceDisplay" class="d-flex align-items-center gap-10">
                    <img v-if="info.revenueWarn" src="@/assets/s2.png" height="24px" class="object-fit-contains" alt="">
                    <span :class="{'green' : info.revenueWarn, 'pink' : !info.revenueWarn}">{{ info.revenueGuidance }}</span>
                </div>
                <div v-if="!dataLoading && guidanceDisplay" class="d-flex align-items-center gap-10">
                    <img v-if="info.labourWarn" src="@/assets/s2.png" height="24px" class="object-fit-contains" alt="">
                    <span :class="{'green' : info.labourWarn, 'pink' : !info.labourWarn}">{{ info.labourGuidance }}</span>
                </div>
            </div>
        </template>

        <template v-if="info.displayType == 'reports'">
            <div class="reports justify-content-between d-flex align-items-center">
                <template v-if="instance_type == 'main' || instance_type == 'sandbox'">
                    <span v-if="!info.isCashUpActivated">End of Day Report</span>
                    <span v-if="info.isCashUpActivated">Reports</span>
                </template>
                <template v-else>
                    <span v-if="!info.isCashUpActivated">End of Day Report</span>
                    <span v-else>Reports</span>
                </template>

                <template v-if="!isEnable">
                    <div v-if="!isLoadingEod && !dataLoading" class="logo-btn cursor-pointer">
                        <i @click="showReports()" class="el-icon-right" id="report-icon"></i>
                    </div>
                    <div v-if="isLoadingEod || dataLoading" class="logo-btn cursor-disable">
                        <i class="el-icon-loading" id="eod-icon"></i>
                    </div>
                </template>
                <template v-else>
                    <template v-if="currentWeekType == 'LAST WEEK'">
                        <div v-if="!dataLoading" class="logo-btn cursor-pointer">
                            <svg @click="openReportOption()" width="25" height="25" viewBox="0 0 69 69" fill="#EA3796" xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_875_484" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="69" height="69">
                                <rect x="0.490234" width="68.4902" height="68.4902" fill="#EA3796"/>
                                </mask>
                                <g mask="url(#mask0_875_484)">
                                <path d="M14.759 22.8301H54.7117V17.1226H14.759V22.8301ZM14.759 62.7827C13.1895 62.7827 11.8458 62.2239 10.7281 61.1061C9.61038 59.9884 9.05151 58.6448 9.05151 57.0752V17.1226C9.05151 15.553 9.61038 14.2093 10.7281 13.0916C11.8458 11.9739 13.1895 11.415 14.759 11.415H17.6128V5.70752H23.3203V11.415H46.1504V5.70752H51.8579V11.415H54.7117C56.2812 11.415 57.6249 11.9739 58.7426 13.0916C59.8603 14.2093 60.4192 15.553 60.4192 17.1226V33.3176C59.5155 32.8896 58.588 32.5329 57.6368 32.2475C56.6855 31.9621 55.7105 31.7481 54.7117 31.6054V28.5376H14.759V57.0752H32.7377C33.0707 58.1216 33.4631 59.1204 33.9149 60.0716C34.3667 61.0229 34.9018 61.9266 35.5201 62.7827H14.759ZM51.8579 65.6365C47.9102 65.6365 44.5452 64.2453 41.7627 61.4629C38.9803 58.6804 37.5891 55.3154 37.5891 51.3677C37.5891 47.42 38.9803 44.0549 41.7627 41.2725C44.5452 38.4901 47.9102 37.0989 51.8579 37.0989C55.8056 37.0989 59.1707 38.4901 61.9531 41.2725C64.7355 44.0549 66.1267 47.42 66.1267 51.3677C66.1267 55.3154 64.7355 58.6804 61.9531 61.4629C59.1707 64.2453 55.8056 65.6365 51.8579 65.6365ZM56.638 58.1454L58.6356 56.1477L53.2848 50.7969V42.8064H50.431V51.9384L56.638 58.1454Z" fill="#EA3796"/>
                                </g>
                            </svg>
                        </div>
                        <div v-else class="logo-btn cursor-disable">
                            <i class="el-icon-loading"></i>
                        </div>
                    </template>
                </template>
            </div>
        </template>

    </div>
</template>

<script>
export default {
    data() {
        return {
            rosterDisplay: 1,
            guidanceDisplay: false,
            instance_type: process.env.INSTANCE_TYPE,
        }
    },
    props: {
        venueId: {
            default: null,
        },
        headerTitle: {
            default: ''
        },

        value: {
            default: '$0.00'
        },

        info: {
            default: null
        },

        dataLoading: {
            default: false
        },
        isLoadingEod: {
            default: false,
        },
        isGstAdded: {
          default: false
        },
        isEnable: {
            default: true
        },
        currentWeekType: {
            default: null,
        },
        isDaily: {
            default: 0
        },
        id: {
            default: null
        },
        isGstAdded: {
          default: false
        }


    },
    methods: {
        rosterChangeDisplay() {
            this.rosterDisplay = this.rosterDisplay + 1
            if (this.rosterDisplay > 3) {
                this.rosterDisplay = 1
            }
        },

        guidanceChangeDisplay() {
            this.guidanceDisplay = !this.guidanceDisplay
        },

        showCashup() {
            this.$emit('show-cashup')
        },

        showReports() {

            if (this.info.isCashUpActivated || this.info.isEosActivated) {
                this.$emit('show-reports-modal')
            } else {
                this.$emit('show-eod-report')
            }
        },

        showWeeklyReports() {
            this.$emit('show-weekly-report')
        },

        showRevenue() {
            if (this.info.title == 'Actual Revenue' || this.info.title == 'Predicted Revenue') {
                this.$emit('show-actual')
            } else if (this.info.title == 'Target Revenue') {
                this.$emit('show-target')
            }
        },

        openReportOption() {
            if (!this.info.isCashUpActivated) {
                this.$emit('show-weekly-report')
            } else {

                this.$emit('show-reports-modal', 1)
            }
        }
    },
    mounted() {
        this.$root.$on('set-roster-display', (set) => {
            this.rosterDisplay = set
        })

        this.$root.$on('set-guidance-display', (set) => {
            this.guidanceDisplay = set
        })
    }
}
</script>

<style lang="scss" scoped>
@import 'static/scss/colors.scss';
@import 'static/scss/fonts/fonts';
@import 'static/scss/media-queries.scss';
    .dashboard-overview-container {
        background: var(--background-color-2);
        border-radius: 12px;
        padding: 20px 2rem !important;
        min-height: 120px;
        width: 100%;

        @include mobile-lg {
            justify-content: center !important;
        }
        &.blue {
            .header h3, .content {
                color: $blue1 !important;
            }
        }
        .option {
            color: var(--primary-color);
            font-size: 24px;
        }

        .header {
            display: flex;
            h3 {
                @include pingfang-font(20px, 30px, 500, $white);
                display: flex;
                align-items: center;
                gap: 10px;

                .el-tag {
                  background-color: rgba(234, 55, 151, 0.1);
                  border-color: rgba(234, 55, 151, 0.2);
                  color: rgb(234, 55, 149);
                }
            }
        }

        .content {
            @include pingfang-font(36px, 54px, 500, $white);

            &.guidance {
                @include pingfang-font(24px, 32px, 500, $white);
                .green {
                    color: $green;
                }
                .pink {
                    color: var(--primary-color);
                }
            }
        }

        .reports {
            height: 100%;

            .logo-btn {
                font-size: 24px;
                color: var(--primary-color);
            }

            @include pingfang-font(24px, 31.2px, 500, $white);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/card/dashboard/overview.vue